import { runInAction } from 'mobx';
import { ocapiClient } from '../../../../../api-clients/ocapi/client';
import { isEmptyArray } from '../../../../../utils/array-utils';
import { createFetchedData } from '../../../../../utils/fetched-data/create-fetched-data';
import { getCacheDuration } from '../../../../../utils/get-cache-duration';
import { isMemberSignedIn } from '../../../selectors/member/is-member-signed-in';
import { getMemberPaymentCards } from '../../../selectors/member/payment-cards/get-member-payment-cards';
import { temporaryLoyaltyDomainStore } from '../../../temporary-store/store';
import { clearCurrentMemberSubscriptionBillingError } from '../subscriptions/clear-current-member-subscription-billing-error';
export const setPrimaryMemberPaymentCard = async (memberPaymentCardId) => {
    if (!isMemberSignedIn())
        throw new Error('Cannot assign primary payment card when no user is signed in');
    const memberPaymentCards = getMemberPaymentCards();
    if (!memberPaymentCards) {
        throw new Error('Cannot set primary member payment card. Member payment cards have not been loaded.');
    }
    if (isEmptyArray(memberPaymentCards)) {
        throw new Error('Cannot set primary member payment card. Member has no payment cards.');
    }
    if (!memberPaymentCards.find(card => card.id === memberPaymentCardId)) {
        throw new Error(`Cannot set primary member payment card. Card with id: '${memberPaymentCardId}' does not exist.`);
    }
    await ocapiClient.instance.v1.loyalty.members.paymentCards.setPrimary({ memberPaymentCardId });
    runInAction(() => {
        temporaryLoyaltyDomainStore.data.memberPaymentCards = createFetchedData(memberPaymentCards.map(card => (Object.assign(Object.assign({}, card), { isPrimary: card.id === memberPaymentCardId }))), getCacheDuration('member'));
        clearCurrentMemberSubscriptionBillingError();
    });
};
